<template>
    <div class="row search-bar-wrapper">
        <Searchbar></Searchbar>
        <MapTableSwitch></MapTableSwitch>
    </div>
</template>

<script>
    import Searchbar from "./Searchbar";
    import MapTableSwitch from "./MapTableSwitch";

    /**
     * This is the second row at the main Dashboard page.
     * Wraps up the search and the toggler buttons.
     */

    export default {
        name: "SearchSwitcherWrapper",
        components: {Searchbar, MapTableSwitch }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/variables";

    .search-bar-wrapper {
        height: 64px;
        background: $whiteColor 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.051);
        border: none;
        opacity: 1;
        z-index: 1;
        margin-top: 10px;
    }
</style>